module.exports = __webpack_public_path__ + "static/media/error_network_img.e024bb73.png";